module.exports = __webpack_public_path__ + "static/img/missing-face.01b4ac4f.png";